import { faCircle, faEllipsisVertical, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Button, Col, Container, Dropdown, Form, Image, Row, Table } from "react-bootstrap";
import { Build_Img, Delete_2, Edit_2, Filters } from "../../../../../assets/images";
import { renderImage } from "../../../../Helper/General";
import * as Constants from "../../../../Helper/constants/constants";
import Loader from "../../../../Helper/loader";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import NoDataComponent from "../../../CommanComponents/NoDataComponent";
import PaginationComponent from "../../../CommanComponents/Pagination";
import DeleteModal from "../../../Modals/DeleteModal";
import DepartmentListFunctions from "./function";
import DepartmentListFilterModal from "../../../Modals/DepartmentListingFilters.jsx";

const Department = () => {
    const {
        checkPermissions,
        getModulePermissions,
        getDepartListing,
        loader,
        departList,
        searchDepartment,
        searchInput,
        updateDepartStatus,
        navigate,
        handleDeleteDepartment,
        deletePopup,
        setDeletePopup,
        handleDelete,
        deleteItem,
        page,
        handleBackClick,
        handleNextClick,
        handlePage,
        totalPages,
        handleBreadcrumDataNaviagtion,
        breadcrumData,
        breadcrumItem,
        totalCount,
        showFilterModal,
        setShowFilterModal,
        filtersAppliedSign,
        applyFilters,
        handleClearAllFilters,
        setReduxValue,
    } = DepartmentListFunctions();


    useEffect(() => {
        getModulePermissions();
    }, []);


    return (
        <div className="role_list_screen ward_list_area Department_list_area">
            <WithoutImageHeader
                header={Constants.DEPARTMENT_LIST}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                lefticon={"menu"}
                handleBreadcrumDataNaviagtion={(i) => handleBreadcrumDataNaviagtion(i)}
                setReduxvalue={(e) => setReduxValue(e)}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="role_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>Total Departments: {totalCount ? totalCount : 0}</p>
                                </div>
                                {/* {
                                    checkPermissions
                                        && checkPermissions.permissions
                                        && checkPermissions.permissions.length > 1
                                        && parseInt(checkPermissions.permissions[1].value) === 1 ? */}
                                <div className="right_area">
                                    <a className="btn btn-primary" href="/add-departement">Add Department</a>
                                </div>
                                {/* :
                                        null
                                } */}
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search by departemnt name here"
                                                value={searchInput}
                                                onChange={(e) => searchDepartment(e.target.value)}
                                            />
                                            <a>
                                                <div className="icon">
                                                    <FontAwesomeIcon icon={faSearch} />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="filter_button">
                                    <Button
                                        className={filtersAppliedSign ? "btn-primary" : 'btn-border'}
                                        onClick={() => setShowFilterModal(true)}
                                    >
                                        <Image
                                            src={Filters}
                                            alt="..."
                                            className="image_area"
                                        />
                                        Filters</Button>
                                    {
                                        filtersAppliedSign ?
                                            <FontAwesomeIcon
                                                icon={faCircle}
                                                className="filter_icon"
                                            />
                                            :
                                            null
                                    }
                                </div>
                            </div>

                            {loader ? (
                                <Loader loader={loader} />
                            ) : (
                                <>
                                    {!loader && departList && departList.length > 0 ? (
                                        <div className="list_detail">
                                            <div className="list_data">
                                                <Table responsive>
                                                    <tr>
                                                        <th className="role_text">
                                                            Hospital Name
                                                        </th>
                                                        <th>Department Name</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {departList && departList.length > 0
                                                        ? departList.map(
                                                            (item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <div className="profile_info">
                                                                                <div className="left_area">
                                                                                    <div className="img_profile">
                                                                                        <Image src={item && item.hospitals && item.hospitals[0] && item.hospitals[0].image ? renderImage(item.hospitals[0].image) : Build_Img} alt="..." />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="right_area">
                                                                                    <p>{item && item.hospitals && item.hospitals[0] && item.hospitals[0].title ? item.hospitals[0].title : null}</p>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="label">
                                                                                <p>{item.title}</p>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="switch_area">
                                                                                <Form>
                                                                                    <Form.Check
                                                                                        type="switch"
                                                                                        id="custom-switch"
                                                                                        label={parseInt(item.status) === 1 ? "Active" : "Inactive "}
                                                                                        checked={parseInt(item.status) === 1 ? true : false}
                                                                                        onClick={() => updateDepartStatus(item)}
                                                                                    />
                                                                                </Form>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                // (checkPermissions
                                                                                //     && checkPermissions.permissions
                                                                                //     && checkPermissions.permissions.length > 2
                                                                                //     && parseInt(checkPermissions.permissions[2].value) === 1) ||
                                                                                //     (checkPermissions
                                                                                //         && checkPermissions.permissions
                                                                                //         && checkPermissions.permissions.length > 3
                                                                                //         && parseInt(checkPermissions.permissions[3].value) === 1)
                                                                                //     ?
                                                                                    <div className="icon">
                                                                                        <Dropdown>
                                                                                            <Dropdown.Toggle
                                                                                                variant="none"
                                                                                                id="dropdown-basic"
                                                                                            >
                                                                                                <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                                            </Dropdown.Toggle>
                                                                                            <Dropdown.Menu>
                                                                                                {/* {
                                                                                                    checkPermissions
                                                                                                        && checkPermissions.permissions
                                                                                                        && checkPermissions.permissions.length > 2
                                                                                                        && parseInt(checkPermissions.permissions[2].value) === 1 ? */}
                                                                                                        <Dropdown.Item onClick={() => navigate("/add-departement", { state: { name: "EditDepartment", id: item.id, }, })} >
                                                                                                            Edit
                                                                                                            <Image src={Edit_2} alt="..." className="image_area" />
                                                                                                        </Dropdown.Item>
                                                                                                {/* //         :
                                                                                                //         null
                                                                                                // } */}
                                                                                                {/* {
                                                                                                    checkPermissions
                                                                                                        && checkPermissions.permissions
                                                                                                        && checkPermissions.permissions.length > 3
                                                                                                        && parseInt(checkPermissions.permissions[3].value) === 1 ? */}
                                                                                                        <Dropdown.Item onClick={() => handleDelete(item)} >
                                                                                                            Delete
                                                                                                            <Image src={Delete_2} alt="..." className="image_area delete_icon " />
                                                                                                        </Dropdown.Item>
                                                                                                        {/* :
                                                                                                        null
                                                                                                } */}
                                                                                            </Dropdown.Menu>
                                                                                        </Dropdown>
                                                                                    </div>
                                                                                    // :
                                                                                    // null
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        )
                                                        : null}
                                                </Table>
                                            </div>
                                        </div>
                                    ) : (
                                        <NoDataComponent message="No Department Found" />
                                    )}
                                </>)}
                            {!loader && departList && departList.length > 0 ? (
                                <PaginationComponent
                                    page={page}
                                    setPage={handlePage}
                                    totalPages={totalPages}
                                    handleBackClick={handleBackClick}
                                    handleNextClick={handleNextClick}
                                />
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </Container>
            {deletePopup ? (
                <DeleteModal
                    show={deletePopup}
                    handleSubmit={() => handleDeleteDepartment(deleteItem)}
                    close={() => setDeletePopup(false)}
                    message={"Do you want to delete this Department?"}
                />
            ) : null}
            {
                showFilterModal ?
                    <DepartmentListFilterModal
                        show={showFilterModal}
                        applyFilters={applyFilters}
                        handleClearAllFilters={handleClearAllFilters}
                        close={() => setShowFilterModal(false)}
                    />
                    :
                    null
            }
        </div>
    );
};

export default Department;
